import { render, staticRenderFns } from "./AutoRefresh.vue?vue&type=template&id=37fbcf45&scoped=true&"
import script from "./AutoRefresh.vue?vue&type=script&lang=js&"
export * from "./AutoRefresh.vue?vue&type=script&lang=js&"
import style0 from "./AutoRefresh.vue?vue&type=style&index=0&id=37fbcf45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fbcf45",
  null
  
)

export default component.exports